import { Component, OnInit, HostBinding, ElementRef, OnChanges, Input, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-progress-circle',
    templateUrl: './progress-circle.component.html',
    styleUrls: ['./progress-circle.component.scss']
})
export class ProgressCircleComponent implements OnInit, OnChanges {
    // @HostBinding('style.--target-circle')
    @Input() targetPercentage;
    @Input() showPercentage = false;
    @Input() isMobile = false;

    constructor(private host: ElementRef<HTMLElement>) { }

    ngOnInit() {
        // this.host.nativeElement.style.setProperty(`--target-circle`, `${((this.targetPercentage * 3.6) / 2)}deg`);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.targetPercentage.previousValue !== changes.targetPercentage.currentValue) {
            this.host.nativeElement.style.setProperty(`--target-circle`, `${((changes.targetPercentage.currentValue * 3.6) / 2)}deg`);
        }
    }

}
